<template>
	<div class="game-rating">
		<!-- Show ESRB logo for North America & South America -->
		<img v-if="esrbRegions.indexOf(countryCode) > -1" class="game-rating__img" src="../../images/game-rating/esrb-en.png" />

		<!-- Show PEGI Logo for Europe exclude DE for Germany -->
		<img
			v-if="pegiRegions.indexOf(countryCode) > -1 && countryCode !== 'DE'"
			class="game-rating__img"
			:src="require(`../../images/game-rating/pegi-${getPegiImgLang(countryCode)}.png`)"
		/>

		<!-- Show USK Logo for Germany -->
		<img v-if="countryCode === 'DE'" class="game-rating__img" src="../../images/game-rating/usk-0.png" />

		<!-- Show ACB Logo for Oceania -->
		<!-- <div v-if="Oceania.indexOf(countryCode) > -1" :class="`game-rating__acb-${formatedGameName}`"></div> -->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
	name: 'GameRating',
	props: {
		gameName: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			NorthAmerica: [
				'AI',
				'AG',
				'AW',
				'BS',
				'BB',
				'BZ',
				'BM',
				'BQ',
				'VG',
				'CA',
				'KY',
				'CR',
				'CU',
				'CW',
				'DM',
				'DO',
				'SV',
				'GL',
				'GD',
				'GP',
				'GT',
				'HT',
				'HN',
				'JM',
				'MQ',
				'MX',
				'PM',
				'MS',
				'CW',
				'KN',
				'NI',
				'PA',
				'PR',
				'BQ',
				'BQ',
				'SX',
				'KN',
				'LC',
				'PM',
				'VC',
				'TT',
				'TC',
				'US',
				'VI',
			],
			SouthAmerica: ['AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'FK', 'GF', 'GY', 'GY', 'PY', 'PE', 'SR', 'UY', 'VE'],
			Europe: [
				'AL',
				'AD',
				'AT',
				'BY',
				'BE',
				'BA',
				'BG',
				'HR',
				'CY',
				'CZ',
				'DK',
				'EE',
				'FO',
				'FI',
				'FR',
				'DE',
				'GI',
				'GR',
				'HU',
				'IS',
				'IE',
				'IT',
				'LV',
				'LI',
				'LT',
				'LU',
				'MK',
				'MT',
				'MD',
				'MC',
				'NL',
				'NO',
				'PL',
				'PT',
				'RO',
				'RU',
				'SM',
				'RS',
				'SK',
				'SI',
				'ES',
				'SE',
				'CH',
				'UA',
				'GB',
				'VA',
				'RS',
				'IM',
				'RS',
				'ME',
			],
			// Oceania: ['AU', 'NZ'],
		};
	},
	computed: {
		...mapState(['countryInfo']),
		esrbRegions() {
			return this.NorthAmerica.concat(this.SouthAmerica);
		},
		pegiRegions() {
			return this.Europe;
		},
		countryCode() {
			return this.countryInfo.country;
		},
		formatedGameName() {
			return this.gameName.replace(/[ :]+/g, '-').toLowerCase();
		},
	},
	async created() {
		await this.checkCountryInfo();
	},
	methods: {
		...mapActions(['checkCountryInfo']),
		getPegiImgLang(code) {
			const pegiImgLangList = ['FR', 'IT', 'ES', 'PT'];
			const targetPegi = pegiImgLangList.find((lang) => lang === code) || 'EN';
			return targetPegi.toLowerCase();
		},
	},
};
</script>

<style lang="less">
.game-rating {
	color: white;
	&__img {
		margin-top: 20px;
		height: 105px;
	}
}
@media (min-width: 1024px) {
	.game-rating {
		&__img {
			margin-top: 7px;
			height: 105px;
		}
	}
}
@media (min-width: 1280px) {
	.game-rating {
		&__img {
			margin-top: 7px;
			height: 105px;
		}
	}
}
@media (min-width: 1440px) {
	.game-rating {
		&__img {
			margin-top: 20px;
			height: 135px;
		}
	}
}
@media (min-width: 1920px) {
	.game-rating {
		&__img {
			height: 135px;
		}
	}
}
</style>
